import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    data() {
      return {
        loading: false,
        showNotice: true,
        successMessage: '',
        form: {
          registrationType: '',
          company: '',
          mcRepFirst: '',
          mcRepLast: '',
          mcGuestFirst: '',
          mcGuestLast: '',
          boardFirst: '',
          boardLast: '',
          boardGuestFirst: '',
          boardGuestLast: '',
          selectedNominees: [],
          additionalAttendees: [],
          contactFirstName: '',
          contactLastName: '',
          contactCompany: '',
          contactEmail: '',
          contactPhone: '',
          contactNotes: '',
          agreeToTerms: false,
          paymentType: '',
          useRegistrationContact: false,
          cardHolderFirstName: '',
          cardHolderLastName: '',
          cardHolderCompany: '',
          cardHolderEmail: '',
          addressStreet1: '',
          addressStreet2: '',
          addressCity: '',
          addressState: '',
          addressZipcode: '',
          cardNumber: '',
          cardExpireMonth: '',
          cardExpireYear: '',
          cardCVV: ''
        },
        ticketPrice: 0,
        mcCompanies: [],
        boardCompanies: [],
        nominees: [],
      };
    },
    mounted(){ 
      this.collectData()
    },
    methods: { 
      collectData(){
        window.coolHelperFunctions.coolAjax({ action: 'collect_award_banquet_data' }, json => {
          this.mcCompanies = json?.data?.mc_companies
          this.boardCompanies = json?.data?.board_member_companies
          this.nominees = json?.data?.rose_nominees
          this.ticketPrice = json?.data?.ticket_price
        }, err => alert(`Something went wrong. Please try again later. ${err}`))
      },
      createEmptyAdditionalAttendee(){
        return { first_name: '', last_name: '' }
      },
      handleFormSubmit(){
        this.loading = true
        window.coolHelperFunctions.coolAjax({ 
          action: 'submit_awards_banquet_registration', 
          recaptcha_token: document.querySelector('[name="recaptcha_token"]').value,
          form: this.form 
        }, json => {
          this.loading = false
          if(json?.data?.message){
            if(json.success){
              this.successMessage = json.data.message
            } else {
              alert(json.data.message)
              window.coolReCaptchaRefresh()
            }
          } else {
            alert("Unexpected result from server. Please try again later.")
            window.coolReCaptchaRefresh()
          }
        }, err => {
          this.loading = false
          alert(err)
          window.coolReCaptchaRefresh()
        })
      }
    },
    watch: {
      'form.registrationType': {
        deep: true,
        handler(newVal) {
          if(newVal == 'General Attendee Registration' && this.form.additionalAttendees.length == 0){
            this.form.additionalAttendees.push(this.createEmptyAdditionalAttendee())
          }
        },
      },
      'form.company': {
        deep: true,
        handler(newVal) {
          // any time the company is updated, reset the selected nominees too
          this.form.selectedNominees = []
        },
      },
      'form.contactFirstName': {
        deep: true,
        handler(newVal){
          if(this.form.useRegistrationContact){
            this.form.cardHolderFirstName = this.form.contactFirstName
          }
        }
      },
      'form.contactLastName': {
        deep: true,
        handler(newVal){
          if(this.form.useRegistrationContact){
            this.form.cardHolderLastName = this.form.contactLastName
          }
        }
      },
      'form.contactCompany': {
        deep: true,
        handler(newVal){
          if(this.form.useRegistrationContact){
            this.form.cardHolderCompany = this.form.contactCompany
          }
        }
      },
      'form.contactEmail': {
        deep: true,
        handler(newVal){
          if(this.form.useRegistrationContact){
            this.form.cardHolderEmail = this.form.contactEmail
          }
        }
      },
      'form.useRegistrationContact': {
        deep: true,
        handler(newVal) {
          if(newVal){
            this.form.cardHolderFirstName = this.form.contactFirstName
            this.form.cardHolderLastName = this.form.contactLastName
            this.form.cardHolderCompany = this.form.contactCompany
            this.form.cardHolderEmail = this.form.contactEmail
          }
        }
      },

    },
    computed: {
      totalPayment(){
        let total = 0
        if(this.form.additionalAttendees.length){
          total += this.ticketPrice * this.form.additionalAttendees.length
        }

        return total
      },
      roseCompanies(){
        // collect unique rose companies and sort by name
        const unique = {}
        for (const n of this.nominees) {
          const c = n.company
          if (c && !unique[c.id]) unique[c.id] = c
        }
        return Object.values(unique).sort((a, b) => a.name.localeCompare(b.name))
      },
      filteredRoseNominees() {
        return this.form.company?.id ? this.nominees.filter(n => n.company.id == this.form.company.id) : []
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.awards-banquet-registration')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}